import { Heading, Section, Stack } from "@carbon/react";
import { FC } from "react";

import { AlertsHistoryTable } from "src/components/Alerts/AlertsHistoryTable";
import WidgetContainer, {
  WidgetContainerProps,
} from "src/dynamic-view-renderer/Widgets/WidgetContainer.tsx";
import { useT } from "src/internationalization";
import { ShortAlert } from "src/types/alert";

export type CaseAlertsWidgetProps = {
  data?: {
    alerts?: ShortAlert[];
    snapshotMode?: boolean;
  };
} & Omit<WidgetContainerProps, "children">;

const CaseAlertsWidget: FC<CaseAlertsWidgetProps> = ({ data, ...containerProps }) => {
  const t = useT();

  if (data?.snapshotMode) return undefined;
  if (!data?.alerts?.length) {
    return (
      <WidgetContainer
        {...containerProps}
        rowConfiguration={{
          ...containerProps.rowConfiguration,
          height: 100,
        }}
      >
        <Stack gap={2} className="text-center">
          <Section level={4} className="mb-2">
            <Heading>{t("component.widget.case.alerts.empty.title")}</Heading>
          </Section>
          <div>
            <div>{t("component.widget.case.alerts.empty.description")}</div>
            <div>{t("component.widget.case.alerts.empty.suggestion")}</div>
          </div>
        </Stack>
      </WidgetContainer>
    );
  }

  return (
    <WidgetContainer {...containerProps}>
      <AlertsHistoryTable alerts={data.alerts} openInNewTab={false} hideTitle />
    </WidgetContainer>
  );
};

export default CaseAlertsWidget;
